module.exports = __webpack_public_path__ + "img/组 3.e09d8e31.webp";